import PropTypes from 'prop-types';
import styles from './FJTextToVideoScriptEdit.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton';
import FJScriptEditorInputContainer from '../FJScriptEditorInput/FJScriptEditorInputContainer';
import FJSceneTextListContainer from '../FJSceneTextbox/FJSceneTextListContainer';
import classNames from 'classnames';
import FJTextToVideoFooter from '../FJTextToVideoFooter/FJTextToVideoFooter';
// import { useMemo } from 'react';

const FJTextToVideoScriptEdit = props => {
    const { onEditNext, isShowEditInput } = props;
    // const sceneContainerH = () => {
    //     const scriptEditorInput = document.getElementById('script-editor-input');
    //     const scriptEditorInputH = scriptEditorInput?.offsetHeight || 129;
    //     const headerH = 108;
    //     const space = 20 + 30;
    //     const deductH = scriptEditorInputH + headerH + space;
    //     return isShowEditInput ? `calc(100% - ${deductH}px)` : `calc(100% - ${headerH}px)`;
    // };
    return (
        <div className={styles.container}>
            {isShowEditInput && <FJScriptEditorInputContainer />}
            <div
                className={classNames(styles.scene_container, isShowEditInput && styles.margin_top_30)}
                // style={{ height: sceneContainerH() }}
                // style={{ height: isShowEditInput ? 'calc(100% - 307px)' : 'calc(100% - 130px)' }}
            >
                <FJSceneTextListContainer />
            </div>
            <FJTextToVideoFooter>
                <FJButton
                    text={FJLocalStore._('next')}
                    className={styles.btn}
                    type={FJButtonType.GRADIENT}
                    onClick={onEditNext}
                />
            </FJTextToVideoFooter>
        </div>
    );
};

FJTextToVideoScriptEdit.propTypes = {
    sceneTextList: PropTypes.array,
    updateSceneTextList: PropTypes.func,
    onEditNext: PropTypes.func,
    isShowEditInput: PropTypes.bool,
};

export default FJTextToVideoScriptEdit;
